<template>
  <v-container class="mt-2">
    <v-card class="px-2 pb-2">
      <v-row>
        <v-col>
          <p>Regra de Aceitação - Detalhar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="remove">
            <v-icon small title="Remover">fas fa-trash</v-icon>
          </v-btn>
          <v-btn class="mx-1" small @click="edit">
            <v-icon small title="Editar">fas fa-edit</v-icon>
          </v-btn>
          <v-btn small @click="goBack">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-skeleton-loader
        v-if="!acceptanceRule"
        type="article, actions"
      ></v-skeleton-loader>

      <v-row v-if="acceptanceRule">
        <v-col cols="5">
          <strong>Código</strong>
          {{acceptanceRule.code}}
        </v-col>
        <v-col cols="7">
          <strong>Descrição</strong>
          {{acceptanceRule.description}}
        </v-col>
        <v-col cols="5">
          <strong>Mínimo de vidas</strong>
          {{acceptanceRule.minimumLives}}
        </v-col>
        <v-col cols="7">
          <strong>Máximo de vidas</strong>
          {{acceptanceRule.maximumLives}}
        </v-col>
      </v-row>

      <v-divider class="mt-2 mb-2"></v-divider>

      <v-container fluid>
        <v-row justify="center">
          <v-expansion-panels accordion>
            <v-expansion-panel @click="toggleCarriersActions">
              <v-expansion-panel-header>
                <v-row class="mr-2">
                  <v-col cols="9">Operadora</v-col>
                  <v-col
                    cols="3"
                    class="d-flex justify-end"
                    v-if="showCarriersActions"
                  >
                    <v-btn class="mr-1" small @click.native.stop="$refs.carrierSearch.show">
                      <v-icon small title="Adicionar">fas fa-plus</v-icon>
                    </v-btn>
                    <v-btn small @click.native.stop="$refs.carriers.removeAll">
                      <v-icon small title="Remover">fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <acceptance-rule-carrier
                  ref="carriers"
                  :acceptance-rule-id="id"
                ></acceptance-rule-carrier>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <carrier-search
              ref="carrierSearch"
              :acceptance-rule-id="id"
              @selected="addAccount"
            ></carrier-search>
          </v-expansion-panels>
          <v-expansion-panels>
            <v-expansion-panel @click="togglePlansActions">
              <v-expansion-panel-header>
                <v-row  class="mr-2">
                  <v-col cols="9">Plano Operadora</v-col>
                  <v-col
                    cols="3"
                    class="d-flex justify-end"
                    v-if="showPlansActions"
                  >
                    <v-btn small @click.native.stop="$refs.productSearch.show">
                      <v-icon small title="Adicionar">fas fa-plus</v-icon>
                    </v-btn>
                    <v-btn small @click.native.stop="$refs.plans.removeAll">
                      <v-icon small title="Remover">fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <acceptance-rule-product
                  ref="plans"
                  :acceptance-rule-id="id"
                ></acceptance-rule-product>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <product-search
              ref="productSearch"
              :acceptance-rule-id="id"
              @selected="addProduct"
            ></product-search>
          </v-expansion-panels>

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row  class="mr-2">
                  <v-col cols="9">Informações do Registro</v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row v-if="acceptanceRuleRevision">
                  <v-col cols="6">
                    <strong>Usuário de criação:</strong> {{acceptanceRuleRevision.createdBy}}
                  </v-col>
                  <v-col cols="6">
                    <strong>Usuário da última alteração:</strong> {{acceptanceRuleRevision.createdBy}}
                  </v-col>
                  <v-col cols="6">
                    <strong>Data de criação:</strong> {{$util.formatDateToBR(acceptanceRuleRevision.createdAt)}}
                  </v-col>
                  <v-col cols="6">
                    <strong>Data da última alteração:</strong> {{$util.formatDateToBR(acceptanceRuleRevision.updatedAt)}}
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <product-search
              ref="productSearch"
              :acceptance-rule-id="id"
              @selected="addProduct"
            ></product-search>
          </v-expansion-panels>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AcceptanceRuleProduct from "@/view/acceptance_rule/acceptance_rule_products";
import AcceptanceRuleCarrier from "@/view/acceptance_rule/acceptance_rule_carriers";
import ProductSearch from "@/view/acceptance_rule/acceptance_rule_product_search";
import CarrierSearch from "@/view/acceptance_rule/acceptance_rule_carrier_search";
import AcceptanceRulePlanService from "@/services/insurancepricing/AcceptanceRulePlanService";
import AcceptanceRuleCarrierService from "@/services/insurancepricing/AcceptanceRuleCarrierService";

export default {
  components: { AcceptanceRuleProduct, ProductSearch, CarrierSearch, AcceptanceRuleCarrier },
  data() {
    return {
      id: this.$route.params.id,
      acceptanceRule: null,
      isLoading: false,
      acceptanceRulePlans: [],
      showPlansActions: false,
      showCarriersActions: false,
    };
  },
  async created() {
    this._acceptanceRulePlanService = new AcceptanceRulePlanService();
    this._acceptanceRuleCarrierService = new AcceptanceRuleCarrierService();
    this.CLEAR_ACCEPTANCERULE_DESCRIPTIONS();
    this.fetchAcceptanceRule(this.id)
        .then((data) => {
          this.acceptanceRule = data
        })
        .finally(() => {
          this.isLoading = false;
        });
    this.fetchAcceptanceRuleRevision(this.id)
  },
  computed: {
    ...mapGetters("acceptanceRule", ["acceptanceRuleProcessed", "getAcceptanceRule", "acceptanceRuleRevision"]),
  },
  methods: {
    ...mapActions("acceptanceRule", ["deleteAcceptanceRule", "fetchAcceptanceRule", "fetchAcceptanceRuleRevision"]),
    ...mapMutations(["toogleDialogLoading", 'showmsg']),
    ...mapMutations('acceptanceRule', ['CLEAR_ACCEPTANCERULE_DESCRIPTIONS']),
    edit() {
      this.$router.push(`/acceptance_rule/${this.id}/edit`);
    },
    async remove() {
      this.toogleDialogLoading(true);
      await this.deleteAcceptanceRule(this.id);
      this.goBack();
      this.toogleDialogLoading(false);
    },
    togglePlansActions() {
      this.$refs.productSearch.resetData();
      this.showPlansActions = !this.showPlansActions;
    },
    toggleCarriersActions() {
      this.showCarriersActions = !this.showCarriersActions;
    },
    async addProduct(products) {
      this.toogleDialogLoading(true);
      const bodyFormData = new FormData();
      products.forEach((product) => bodyFormData.append('planIds', product.id))
      try {
        await this._acceptanceRulePlanService.save(this.id,  bodyFormData)
        this.showmsg({text: 'Planos associados com sucesso'});
        await this.$refs.plans.loadData();
      } catch (e) {
        console.log(e)
      }
      this.toogleDialogLoading(false);
    },
    async addAccount(carriers) {
      this.toogleDialogLoading(true);
      const bodyFormData = new FormData();
      carriers.forEach((carrier) => bodyFormData.append('carrierIds', carrier.id))
      try {
        await this._acceptanceRuleCarrierService.save(this.id,  bodyFormData)
        this.showmsg({text: 'Operadoras associadas com sucesso'});
        await this.$refs.carriers.loadData();
      } catch (e) {
        console.log(e)
      }
      this.toogleDialogLoading(false);
    },    
    goBack() {
      this.$router.push(`/acceptance_rule`);
    },
  },
};
</script>
